// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"53":"58a20f9e","568":"ae9701c2","615":"77b2a425"}[chunkId] + ".css";
};